import { Component, Input, Output, OnInit, EventEmitter, OnChanges } from '@angular/core'

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
})
export class PaginationComponent implements OnInit {
    /*
        <pagination
            [size]='integer'
            [actualPage]='integer'
            [pageSizeOptionsList]='array de integers'
            (pageChange)=''
            (pageSizeChange)=''
        ></pagination>

        ## Os atributos a serem enviados para que o componente funcione são:

        ** size: total de registros que devem ser divididos em páginas

        ** actualPage: Página atual do componente pai

        ** pageSizeOptionsList: lista de números inteiros que informam as possibilidades de quantos registros
        uma página pode ter.
        Exemplo. É enviado a lista [30,60]. Neste caso será exibida na tela as opções de página com 30 ou 60 registros.

        ** pageChange: Evento que retorna o número da página após mudança

        ** pageSizeChange: Evento que retorna a opção de número de registros por página que foi selecionado
    */

    @Input() pageSizeOptionsList: any[] = []
    @Input() amountOfPages: number = 0
    @Output() pageChange = new EventEmitter<{}>()
    @Output() pageSizeChange = new EventEmitter<{}>()
    @Input() actualPage: number = 0

    @Input() set size(collectionsSizeValue: any) {
        if (this.collectionsSize != collectionsSizeValue) {
            this.collectionsSize = collectionsSizeValue
            this.calculateAmountOfPages(1)
        }
        this.collectionsSize = collectionsSizeValue
    }

    @Input() radius: number = 0

    collectionsSize: any
    pageSize: any

    ngOnInit() {
        if (
            !this.amountOfPages &&
            this.collectionsSize !== null &&
            this.collectionsSize !== undefined &&
            this.actualPage &&
            this.pageSizeOptionsList.length > 0
        ) {
            if (typeof this.pageSizeOptionsList[0] == 'number') {
                this.pageSize = this.pageSizeOptionsList[0]

                this.calculateAmountOfPages(1)
            }
        } else if (this.collectionsSize) {
            this.pageSize = this.collectionsSize
        }
    }

    calculateAmountOfPages(recursiveTryNumber: any) {
        if (this.pageSize) {
            let calculatedAmountOfPages
            if (this.collectionsSize % parseInt(this.pageSize) !== 0) {
                calculatedAmountOfPages = this.collectionsSize / parseInt(this.pageSize) + 1
            } else {
                calculatedAmountOfPages = this.collectionsSize / parseInt(this.pageSize)
            }
            // @ts-ignore
            this.amountOfPages = parseInt(calculatedAmountOfPages)
        } else {
            if (recursiveTryNumber <= 6) {
                this.calculateAmountOfPages(recursiveTryNumber + 1)
            }
        }
    }

    nextPage() {
        let goToPage = Math.floor(this.actualPage) + 1
        if (goToPage <= this.amountOfPages) {
            this.pageChange.emit(goToPage)
        }
    }

    previousPage() {
        let goToPage = Math.floor(this.actualPage) - 1
        if (goToPage >= 1) {
            this.pageChange.emit(goToPage)
        }
    }

    changePageSize() {
        this.calculateAmountOfPages(1)
        this.pageSizeChange.emit(this.pageSize)
    }
}
